import { observer } from "mobx-react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { interactionStore } from "@/stores/Stores";

export const BusyIndicator = observer(
  () =>
    interactionStore.loading && (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "#00000036",
          zIndex: "1000000",
        }}
      >
        <LinearProgress
          sx={{
            position: "absolute",
            top: 0,
            width: "100%",
          }}
        />
      </Box>
    ),
);
